var simpleService = angular.module('simpleService', []);

simpleService.service( 'wpService',
function($http, $q){
 
    var url = WPAPI.api_url+'/';
 
    return({
        base: base,
        custom: custom,
        search: search,
        posts: posts,
        postsPaged: postsPaged,
        post_by_slug: post_by_slug,
        types: types,
        taxonomies: taxonomies,
        terms: terms,
        term: term,
        page: page,
        getByType: getByType,
        getByTypePaged: getByTypePaged,
        getBySlug: getBySlug
    })
 
    function base() {
        return ( $http.get(url)
            .then( handleSuccess, handleError ) );
    }
 
    function custom( path ) {
        return ( $http.get(url+path)
            .then( handleSuccess, handleError ) );
    }
    function search( query, limit, page ) {
        return ( $http.get(url+'posts?type[]=post&type[]=oppskrifter&type[]=filmer&filter[s]='+query+'&filter[posts_per_page]='+limit+'&page='+page)
            .then( handleSuccess, handleError ) );
    }
    function posts(limit) {
        return ( $http.get(url+'posts?type[]=post&type[]=oppskrifter&type[]=filmer&filter[posts_per_page]='+limit)
            .then( handleSuccess, handleError ) );
    }
    function postsPaged(limit, page) {
        return ( $http.get(url+'posts?type[]=post&type[]=oppskrifter&type[]=filmer&filter[posts_per_page]='+limit+'&page='+page)
            .then( handleSuccess, handleError ) );
    }
    function post_by_slug( slug ) {
        return ( $http.get(url+'posts?filter[posts_per_page]=1&filter[name]='+slug)
            .then( handleSuccess, handleError ) );
    }
    function types() {
        return ( $http.get(url+'posts/types')
            .then( handleSuccess, handleError ) );
    }
 
    function taxonomies() {
        return ( $http.get(url+'taxonomies')
            .then( handleSuccess, handleError ) );
    }
 
    function terms( tax ) {
        return ( $http.get(url+'taxonomies/'+tax+'/terms')
            .then( handleSuccess, handleError ) );
    }
 
    function term( tax, term ) {
        return ( $http.get(url+'taxonomies/'+tax+'/terms/'+term)
            .then( handleSuccess, handleError ) );
    }
 
    function page( id ) {
        return ( $http.get(url+'posts/'+id)
            .then( handleSuccess, handleError ) );
    }
 
    function getByType( type, limit ) {
        return ( $http.get(url+'posts?type[]='+type+'&filter[posts_per_page]='+limit)
            .then( handleSuccess, handleError ) );
    }
    function getByTypePaged( type, page, limit ) {
        return ( $http.get(url+'posts?type[]='+type+'&page='+page+'&filter[posts_per_page]='+limit)
            .then( handleSuccess, handleError ) );
    }
 
    function getBySlug( type, slug ) {
        return ( $http.get(url+'posts?type[]='+type+'&filter[posts_per_page]=1&filter[name]='+slug)
            .then( handleSuccess, handleError ) );
    }

 
    function handleSuccess( response ) {
 
        return( response.data );
 
    }
 
    function handleError( response ) {
 
        if ( ! angular.isObject( response.data ) || ! response.data.message ) {
 
            return( $q.reject( "An unknown error occurred." ) );
 
        }
 
        return( $q.reject( response.data.message ) );
    }
});